import { styled } from 'styled-components';
import { motion } from 'framer-motion';

const Main = styled(motion.main)`
  display: flex;
  flex-direction: ${props => (props.$flexDirection ? props.$flexDirection : 'column')};
  gap: ${props => props.theme.spaceLg};
`;

export const MainContent = styled(motion.div)`
  height: calc(
    100vh - (2 * ${props => props.theme.spaceLg}) - var(--nav-height) -
      ${props => props.theme.spaceLg}
  );
  min-height: calc(
    100vh - (2 * ${props => props.theme.spaceLg}) - var(--nav-height) -
      ${props => props.theme.spaceLg}
  );
  width: 100%;
  padding: ${props => props.theme.spaceLg};

  display: flex;
  flex-direction: ${props => (props.$flexDirection ? props.$flexDirection : 'column')};
  align-items: ${props => (props.$alignItems ? props.$alignItems : 'start')};
  gap: ${props => props.theme.spaceLg};

  background-color: ${props => props.theme.foregroundColor};
  border-radius: ${props => props.theme.borderRadiusMd};

  overflow-y: auto;
`;

export default Main;
